import React from 'react';
import { cx } from '../../ui/utils';
import './AppContent.css';

// Asosiy kontent maydoni. enabled=false bo'lsa (login, tizimga kirmagan holatdagi ochiq sahifa)
// hech qanday o'rama qo'shilmaydi — DOM avvalgidek qoladi.
//
// "right" class'i ataylab saqlangan: mavjud global CSS (App.css va Courses/EditCourse.css dagi
// `.right { text-align: right }`) sahifalar ichidagi elementlarga meros bo'lib o'tadi.
// Uni olib tashlash sahifalar kontentining ko'rinishini o'zgartiradi.
// bare — kontentga padding va max-width qo'llanmaydi (masalan sertifikat sahifasi).
function AppContent({ enabled, bare = false, children }) {
  if (!enabled) return <>{children}</>;

  return (
    <main className={cx('right', 'ui-app__content', bare && 'ui-app__content--bare')}>
      <div className="ui-app__content-inner">{children}</div>
    </main>
  );
}

export default AppContent;
